import { Autoplay, Navigation, A11y } from 'swiper';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

const initializedWrappers = new WeakSet();

const initDifferenceCards = (scope = document) => {
    scope.querySelectorAll('.difference-swiper-wr').forEach((wrapper) => {
        const swiperEl = wrapper.querySelector('.swiper');
        const grid = wrapper.querySelector('.recruitment-difference-sec__grid');
        const count = grid?.querySelectorAll('.swiper-slide').length;

        if (initializedWrappers.has(wrapper) || !swiperEl || !count) {
            return;
        }

        initializedWrappers.add(wrapper);
        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');

        swiperOnResize('(max-width: 767px)', swiperEl, {
            modules: [Autoplay, Navigation, A11y],
            slidesPerView: 1,
            spaceBetween: 19,
            threshold: 10,
            watchOverflow: true,
            navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
            breakpoints: {
                552: { slidesPerView: 2, spaceBetween: 20 },
            },
            autoplay: count > 1 ? {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            } : false,
        }, count > 1);

        if (typeof window.lineTitlesFunc === 'function') {
            window.lineTitlesFunc([], {
                getGroups: () => [grid.querySelectorAll('.difference-card__head')],
            });
        }
    });
};

initDifferenceCards();
